module.exports = __webpack_public_path__ + "static/img/whjlImg.9b1f537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whjlImg.png
// module id = MbG5
// module chunks = 2